/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" cx="12" cy="12" r="12" _fill="#8300BF"/><path pid="1" _fill="#FFF" d="M16.5 11.5l-7 6v-12z"/></g>'
  }
})
